<template lang="pug">
  div.event-tendency
    div.summary
      module-title(title="提要")
      div.summary-content {{summary}}
    div.data
      tendency-quota(:quotas="quotas")
      tendency-change(:change="change")
    tendency-chart
</template>

<script>
import ModuleTitle from '../EventCenter/ModuleTitle'
import TendencyQuota from './TendencyQuota'
import TendencyChange from './TendencyChange'
import TendencyChart from './TendencyChart'
import client from '../server/server'
export default {
  name: 'EventTendency',
  components: {
    ModuleTitle,
    TendencyQuota,
    TendencyChange,
    TendencyChart
  },
  data () {
    return {
      quotas: [],
      summary: '',
      change: {
        afterNeg: 0,
        afterPos: 0,
        beforeNeg: 0,
        beforePos: 0
      }
    }
  },
  mounted () {
    this.getEventTendencyQuota()
  },
  methods: {
    getEventTendencyQuota () {
      let params = {
        id: this.$route.params.id
      }
      client.getEventTendencyQuota(params)
        .then(res => {
          if (res.success) {
            let data = res.data
            this.summary = `相关信息${data.articleCount}条，整体传播速率为${data.speed}，热议期持续时长${data.hotTime}。事件整体基调呈${data.maxEmotion}，公关回应后品牌负面舆情较回应前${data.negChange}。`
            this.quotas = [
              {
                name: '热议期持续时间',
                value: data.hotTime,
                compare: data.compareHotTime
              },
              {
                name: '公关回应前传播速度',
                value: data.beforeSpeed,
                compare: data.compareBeforeSpeed
              },
              {
                name: '公关回应后传播速度',
                value: data.afterSpeed,
                compare: data.compareAfterSpeed
              }
            ]
            this.change = {
              afterNeg: data.afterNeg,
              afterPos: data.afterPos,
              beforeNeg: data.beforeNeg,
              beforePos: data.beforePos,
              comparePos: data.comparePos,
              compareNeg: data.compareNeg,
              comparePosType: data.comparePosType,
              compareNegType: data.compareNegType
            }
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .event-tendency{
    .summary{
      padding: 14px;
      background-color: #fff;
      border-radius: 4px;
      .summary-content{
        margin-top: 10px;
        color: #666;
      }
    }
    .data{
      margin-top: 20px;
      display: flex;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventTendency/EventTendency.vue